import React from "react";

const Sidebar: React.FC = () => {
    return (
        <div className="w-64 h-full bg-gray-900 text-gray-300 p-6 shadow-lg">
            <h1 className="text-2xl font-bold mb-4">Dashboard</h1>
            <ul>
                <li className="py-2 px-4 hover:bg-gray-700 cursor-pointer">Home</li>
                <li className="py-2 px-4 hover:bg-gray-700 cursor-pointer">Analytics</li>
                <li className="py-2 px-4 hover:bg-gray-700 cursor-pointer">Settings</li>
                <li className="py-2 px-4 hover:bg-gray-700 cursor-pointer">Profile</li>
            </ul>
        </div>
    );
};

export default Sidebar;
